import { values } from 'lodash';
import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
import { useState } from 'react';
function toCurrencyFormat(controlToCheck) {
  var enteredNumber = '' + controlToCheck.target.value;
  enteredNumber = enteredNumber.replace(/[^0-9\.]+/g, '');
  controlToCheck.target.value = Number(enteredNumber).toLocaleString('en-US', {
    style: 'currency',
    currency: 'INR',
  });
}


export const CtcForm = ({ handleChange, handleBlur, values, errors, touched, initialized }) => {
  const [validationError, setValidationError] = useState('');

  const validateTotalCompensation = (event) => {
    let enteredValue = event.target.value.trim();

    if (!/^\d{1,5}(\.\d{0,5})?$/.test(enteredValue) && enteredValue !== "") {
      setValidationError("Whole Number upto 5 is supported.");
      return;
    }

    setValidationError("");

    handleChange(event);
  };

  return (
    <div className="signite-form">
      <Row className="mb-3">
        <BSForm.Group as={Col} controlId="totalCompensation">
          <BSForm.Label>Total*</BSForm.Label>
          <BSForm.Control
            type="text"
            className={`form-control ${getErrorClass(errors, touched, 'totalCompensation', initialized)}`}
            value={values.totalCompensation}
            name={`totalCompensation`}
            onChange={validateTotalCompensation}
            onBlur={(el) => {
              // toCurrencyFormat(el);
              handleBlur(el);
            }}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'totalCompensation', initialized)}</span>
          {validationError && <span className="errorMessage">{validationError}</span>}

        </BSForm.Group>
        <BSForm.Group as={Col} controlId="fixedCompensation">
          <BSForm.Label>Fixed</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`fixedCompensation`}
            value={values.fixedCompensation}
            onChange={handleChange}
            className={`form-control ${getErrorClass(errors, touched, 'fixedCompensation', initialized)}`}
            onBlur={(el) => {
              //  toCurrencyFormat(el);
              handleBlur(el);
            }}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'fixedCompensation', initialized)}</span>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="variableCompensation">
          <BSForm.Label>Variable</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`variableCompensation`}
            value={values.variableCompensation}
            onChange={handleChange}
            className={`form-control ${getErrorClass(errors, touched, 'variableCompensation', initialized)}`}
            onBlur={(el) => {
              //toCurrencyFormat(el);
              handleBlur(el);
            }}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'variableCompensation', initialized)}</span>
        </BSForm.Group>
      </Row>
      <Row className="mb-3">
        <BSForm.Group as={Col} controlId="bonus">
          <BSForm.Label>Bonus</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`bonus`}
            value={values.bonus}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, 'bonus', initialized)}`}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'bonus', initialized)}</span>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="joiningBonus">
          <BSForm.Label>Joining Bonus</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`joiningBonus`}
            value={values.joiningBonus}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, 'joiningBonus')}`}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'joiningBonus')}</span>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="incentive">

        </BSForm.Group>
      </Row>
      <Row className="mb-3">
        <BSForm.Group as={Col} controlId="epos">
          <BSForm.Label>ESOPS</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`epos`}
            value={values.epos}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, 'epos')}`}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'epos')}</span>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="otherBenefits">
          <BSForm.Label>Other Benefits</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`otherBenefits`}
            value={values.otherBenefits}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, 'otherBenefits')}`}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'otherBenefits')}</span>
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
      </Row>
    </div>
  );
};
